<template>
  <div id="app">
    <Header titulo="Ventas Corporativas" />
    <div class="container">
      <h2 id="dejanos">Formulario de contacto</h2>
      <p class="intro-copy">Si querés comunicarte por teléfono, llamanos al 0800-888-8338 (lunes a viernes de 9:00 a 18:00 h).</p>
    </div>
    <Form :modelos="modelos" :concesionarias="concesionarias" />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Form from "./components/Form.vue";

import axios from "axios";

const API_URL = "https://institucional.vwcontenidos.com.ar/api";

export default {
  name: "app",
  components: {
    Header,
    Form
  },
  data() {
    return {
      loading: true,
      motivos: [],
      formas: [],
      modelos: [],
      concesionarias: []
    };
  },
  mounted: function() {
    axios.get(API_URL+'/informacion/ventas-corporativas').then(response => {
      this.modelos = response.data.modelos;
      this.concesionarias = response.data.concesionarias;
      this.loading = false;
      document.title = "Atención al Cliente | Volkswagen Argentina";
    });
  }
};
</script>

<style lang="scss">
@import "./assets/scss/_vw-tokens.scss";
@import "./assets/scss/_fonts.scss";

html,
body {
  background: $vw-bg;
}

#app {
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  background: $vw-bg;
  color: $vw-content;
  padding-bottom: 2em;
  //padding-top: 7em;
  @media (max-width: 1441px) {
    font-size: 12px;
  }

  #dejanos {
    font-weight: 200;
    color: $vw-blue;
    font-size: 4.3em;
    padding: 0.8em 0 0;
    letter-spacing: -0.015em;
    @media (max-width: 669px) {
      font-size: 2.8em;
    }
    span {
      font-weight: 400;
      letter-spacing: -0.004em;
    }
  }

  .intro-copy {
    font-size: 1.35em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    margin: 1.7em auto 2.2em;
    letter-spacing: -0.004em;
    @media (max-width: 669px) {
      font-size: 1.9em;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      margin: 1em auto 2.2em;
      letter-spacing: 0;
      padding-right: 2.8em;
    }
  }

  @media (min-width: 1640px) {
    .container {
      width: 100%;
      max-width: 1640px;
    }
  }
  .vfl-label,
  .vfl-label-on-input,
  .vfl-label-on-focus {
    color: $vw-blue;
  }
  .select .vfl-label,
  .select .vfl-label-on-input,
  .select .vfl-label-on-focus {
    margin-left: 4px;
  }
  .has-error .vfl-label,
  .has-error .vfl-label-on-input,
  .has-error .vfl-label-on-focus {
    color: #e4002c; // red.60 D6
  }

  // Foco accesible en links y botones (WCAG AA) sobre superficies claras.
  // Los campos de formulario NO usan outline: el foco se comunica con el
  // color del borde activo ($vw-border-selected) — ver Form.vue.
  a:focus-visible,
  button:focus-visible {
    outline: 2px solid $vw-focus-ring;
    outline-offset: 2px;
  }
}

.swal2-popup {
  font-size: 1em;
}
#swal2-title {
  line-height: 1.3;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
}

.swal2-popup .swal2-actions button.swal2-confirm {
  border: none !important;
  border-radius: $vw-radius-pill;
  font-size: 1em;
  padding: 0.5em 2.8em 0.6em;
  letter-spacing: -0.04em;
  color: $vw-on-dark;
  background: $vw-blue;
  margin-bottom: 1em;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  // Hover/active beige para TODOS los botones (newHorizon.60)
  &:hover,
  &:active {
    background: $vw-btn-selected;
    color: $vw-content;
    box-shadow: $vw-shadow-hover;
  }
  &:focus-visible {
    outline: 2px solid $vw-focus-ring;
    outline-offset: 2px;
  }
}

#swal2-content a.btn {
  border: 1px solid $vw-blue;
  border-radius: $vw-radius-pill;
  font-size: 1.2em;
  padding: 0.6em 2.8em;
  letter-spacing: -0.04em;
  color: $vw-blue;
  background: $vw-card;
  margin-bottom: 1em;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  &:hover,
  &:active {
    background: $vw-btn-selected;
    border-color: $vw-btn-selected;
    color: $vw-content;
    box-shadow: $vw-shadow-hover;
  }
  &:focus-visible {
    outline: 2px solid $vw-focus-ring;
    outline-offset: 2px;
  }
}

.swal2-popup #swal2-content {
  font-size: 1.1em;
}
</style>
